import { gql } from 'graphql-request'

export const EXPORT_READER_DASHBOARD = gql`
  query ExportReaderDashboard($startDate: DateTime, $endDate: DateTime) {
    exportReaderDashboard(startDate: $startDate, endDate: $endDate)
  }
`
